import { __makeTemplateObject } from "tslib";
import React from 'react';
import { css, cx } from 'emotion';
import { Icon } from '../Icon/Icon';
import { useStyles } from '../../themes/ThemeContext';
import union from 'lodash/union';
import sortBy from 'lodash/sortBy';
import { LegendTableItem } from './VizLegendTableItem';
/**
 * @internal
 */
export var VizLegendTable = function (_a) {
    var items = _a.items, sortKey = _a.sortBy, sortDesc = _a.sortDesc, itemRenderer = _a.itemRenderer, className = _a.className, onToggleSort = _a.onToggleSort, onLabelClick = _a.onLabelClick, onSeriesColorChange = _a.onSeriesColorChange;
    var styles = useStyles(getStyles);
    var columns = items
        .map(function (item) {
        if (item.getDisplayValues) {
            return item.getDisplayValues().map(function (i) { return i.title; });
        }
        return [];
    })
        .reduce(function (acc, current) {
        return union(acc, current.filter(function (item) { return !!item; }));
    }, ['']);
    var sortedItems = sortKey
        ? sortBy(items, function (item) {
            if (item.getDisplayValues) {
                var stat = item.getDisplayValues().filter(function (stat) { return stat.title === sortKey; })[0];
                return stat && stat.numeric;
            }
            return undefined;
        })
        : items;
    if (!itemRenderer) {
        /* eslint-disable-next-line react/display-name */
        itemRenderer = function (item, index) { return (React.createElement(LegendTableItem, { key: item.label + "-" + index, item: item, onSeriesColorChange: onSeriesColorChange, onLabelClick: onLabelClick })); };
    }
    return (React.createElement("table", { className: cx(styles.table, className) },
        React.createElement("thead", null,
            React.createElement("tr", null, columns.map(function (columnHeader) {
                return (React.createElement("th", { key: columnHeader, className: cx(styles.header, onToggleSort && styles.headerSortable), onClick: function () {
                        if (onToggleSort) {
                            onToggleSort(columnHeader);
                        }
                    } },
                    columnHeader,
                    sortKey === columnHeader && (React.createElement(Icon, { className: styles.sortIcon, name: sortDesc ? 'angle-down' : 'angle-up' }))));
            }))),
        React.createElement("tbody", null, sortedItems.map(itemRenderer))));
};
var getStyles = function (theme) { return ({
    table: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    margin-left: ", ";\n  "], ["\n    width: 100%;\n    margin-left: ", ";\n  "])), theme.spacing.sm),
    header: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n    border-bottom: 1px solid ", ";\n    padding: ", " ", ";\n    text-align: right;\n  "], ["\n    color: ", ";\n    font-weight: ", ";\n    border-bottom: 1px solid ", ";\n    padding: ", " ", ";\n    text-align: right;\n  "])), theme.colors.textBlue, theme.typography.weight.semibold, theme.colors.border1, theme.spacing.xxs, theme.spacing.sm),
    headerSortable: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "]))),
    sortIcon: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme.spacing.sm),
}); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=VizLegendTable.js.map